import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer data-testid="footer" className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-6 md:px-12 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-6">
              <img 
                src="/images/logo.png" 
                alt="Vályog-Mester Logo" 
                className="h-28 w-auto"
                style={{ 
                  filter: 'invert(1) brightness(2)'
                }}
              />
            </div>
            <p className="text-slate-400 leading-relaxed">
              Szakértelem és szenvedély a vályogházak szolgálatában. 
              Megóvjuk Magyarország építészeti örökségét.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-lg font-bold mb-6"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Gyors linkek
            </h4>
            <ul className="space-y-3">
              {[
                { href: "#about", label: "Cégünkről" },
                { href: "#services", label: "Szolgáltatások" },
                { href: "#founder", label: "Rólunk" },
                { href: "#survey", label: "Kapcsolat" },
              ].map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-lg font-bold mb-6"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Kapcsolat
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:+36309669528"
                  data-testid="footer-phone"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                >
                  <div className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center">
                    <Phone className="w-5 h-5" />
                  </div>
                  <span>+36 30 966 9528</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:valyog.mester@gmail.com"
                  data-testid="footer-email"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors"
                >
                  <div className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center">
                    <Mail className="w-5 h-5" />
                  </div>
                  <span>valyog.mester@gmail.com</span>
                </a>
              </li>
              <li>
                <div className="flex items-center gap-3 text-slate-400">
                  <div className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5" />
                  </div>
                  <span>Magyarország<br />Országos kiszállás</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container mx-auto px-6 md:px-12 max-w-7xl py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} Vályog-Mester. Minden jog fenntartva.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/adatvedelem" data-testid="footer-privacy-link" className="text-slate-500 hover:text-white transition-colors">
                Adatvédelem
              </Link>
              <Link to="/sutik" data-testid="footer-cookie-link" className="text-slate-500 hover:text-white transition-colors">
                Cookie szabályzat
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
